import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { ModuleFE_Notifications } from '../../component-modules/ModuleFE_Notifications.js';
import { LL_H_C, LL_V_L } from '../Layouts/index.js';
import { formatTimestamp } from '@nu-art/ts-common';
import './TS_Notifications.scss';
import { TS_ComponentTransition } from '../TS_ComponentTransition/index.js';
import { _className, stopPropagation } from '../../utils/tools.js';
export class TS_Notifications extends ComponentSync {
    // ######################### Static #########################
    overlayClass = 'ts-notification-overlay';
    containerClass = 'ts-notification-container';
    transitionTimeout = 300;
    timeout = undefined;
    // ######################### Life Cycle #########################
    __showNotifications(notifications) {
        if (notifications.length === 0) { //If there are no notifications to show
            //Transition notifications out
            this.setState({ showNotifications: false }, () => {
                //Get rid of notifications in state after they are out of view
                this.timeout = setTimeout(() => {
                    this.setState({ notifications });
                }, this.transitionTimeout);
            });
        }
        else { //There are notifications to show
            clearTimeout(this.timeout);
            this.setState({ notifications: [...notifications], showNotifications: true });
            this.forceUpdate();
        }
    }
    deriveStateFromProps(nextProps) {
        return {
            notifications: [],
            showNotifications: false,
        };
    }
    // ######################### Logic #########################
    onClickToClose = (e, eventType) => {
        ModuleFE_Notifications.hideAllNotifications();
        const elements = document.elementsFromPoint(e.clientX, e.clientY);
        const firstNonNotificationElement = elements.find(item => {
            //not always false, svg className is an object
            if (typeof item.className !== 'string')
                return false;
            return item.className && !item.className.includes(this.overlayClass) && !item.className.includes(this.containerClass);
        });
        const ev = new MouseEvent(eventType, {
            bubbles: true,
            cancelable: true,
            view: firstNonNotificationElement.ownerDocument.defaultView,
            detail: 1,
            screenX: e.screenX,
            screenY: e.screenY,
            clientX: e.clientX,
            clientY: e.clientY,
            ctrlKey: e.ctrlKey,
            altKey: e.altKey,
            shiftKey: e.shiftKey,
            metaKey: e.metaKey,
            button: e.button,
            buttons: e.buttons,
            relatedTarget: firstNonNotificationElement,
        });
        //@ts-ignore
        firstNonNotificationElement.dispatchEvent(ev);
    };
    deletePost = (e, notification) => {
        stopPropagation(e);
        ModuleFE_Notifications.create(notification._id).delete();
        //Next line should be removed when the module dispatches new list after deletion
        this.setState({ notifications: this.state.notifications.filter(item => item._id !== notification._id) });
    };
    onNotificationClick = (e, notification) => {
        stopPropagation(e);
    };
    // ######################### Render #########################
    renderNotification(notification) {
        return _jsxs(LL_V_L, { className: `ts-notification ts-notification__${notification.status}`, onClick: e => this.onNotificationClick(e, notification), children: [_jsxs(LL_H_C, { className: 'ts-notification__header', children: [_jsx("div", { className: 'ts-notification__title', children: notification.title }), _jsx("span", { className: 'ts-notification__close', onClick: (e) => {
                                if (notification.status === 'in-progress') {
                                    ModuleFE_Notifications.hideAllNotifications();
                                    return;
                                }
                                this.deletePost(e, notification);
                            }, children: "\u2715" })] }), _jsx(LL_V_L, { className: 'ts-notification__body', children: _jsx("div", { className: 'ts-notification__message', children: notification.message }) }), _jsx(LL_H_C, { className: 'ts-notification__footer', children: _jsx("div", { className: 'ts-notification__timestamp', children: formatTimestamp('DD/M - hh:mm A', notification.__created) }) })] }, notification._id);
    }
    renderNotifications = () => {
        if (!this.state.notifications.length)
            return '';
        return this.state.notifications.map(notification => this.renderNotification(notification));
    };
    render() {
        const className = _className('ts-notification-container', this.state.notifications.length > 1 ? 'list' : undefined);
        return _jsx(TS_ComponentTransition, { trigger: this.state.showNotifications, transitionTimeout: this.transitionTimeout, children: _jsx("div", { className: 'ts-notification-overlay', onClick: e => this.onClickToClose(e, 'click'), onContextMenu: e => this.onClickToClose(e, 'contextmenu'), children: _jsx(LL_V_L, { className: className, onClick: e => this.onClickToClose(e, 'click'), onContextMenu: e => this.onClickToClose(e, 'contextmenu'), children: this.renderNotifications() }) }) });
    }
}
//# sourceMappingURL=TS_Notifications.js.map